<div class="container-fluid cw-background">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-3 col-sm-offset-5 col-md-3 col-md-offset-5 col-lg-3 col-lg-offset-5">
      <mat-card class="mat-elevation-z8 mt-5 pt-5 pb-5" id="card">
        <div class="text-left go-back">
          <button (click)="goBack()" disableRipple mat-button class="delete-user">
            <mat-icon matPreffix>arrow_back_ios</mat-icon>
            Go Back
          </button>
        </div>

        <h6 class="text-center card-title-page mt-4 mb-4">Change Password:</h6>
        <div class="row d-flex justify-content-center">
          <div class="col-12 col-sm-9 col-sm-offset-1">
            <form [formGroup]="passwordForm">
              <div class="form-group">
                <mat-form-field appearance="fill">
                  <mat-label>Current Password</mat-label>
                  <input type="password" matInput formControlName="oldPassword" />
                  <mat-error *ngIf="passwordForm.hasError('required', 'oldPassword')">
                    Current password is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="fill">
                  <mat-label>New Password</mat-label>
                  <input type="password" matInput formControlName="newPassword" />
                  <mat-error *ngIf="passwordForm.hasError('required', 'newPassword')">
                    New password is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="passwordForm.hasError('minLength', 'newPassword')">
                    Password is <strong>too short</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="fill">
                  <mat-label>Re-enter New Password</mat-label>
                  <input type="password" matInput formControlName="confirmPassword" />
                  <mat-error *ngIf="passwordForm.hasError('required', 'confirmPassword')">
                    Password confirmation is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="passwordForm.hasError('notSame', 'confirmPassword')">
                    Passwords do not match
                  </mat-error>
                </mat-form-field>
              </div>
            </form>

            <div class="form-group-button text-center">
              <button (click)="onSubmit()" class="btn btn-primary"
                [disabled]="passwordForm.pristine || !passwordForm.valid">
                Save
              </button>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
